import React from 'react';
import { useHistory } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import googleLogin from "../services/googleLoginService";
import * as img from "../routing/LoginPage/img/GoogleLogo";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    [theme.breakpoints.up('xs')]: {
        btn: {
            height: "48px",
            textTransform: 'none',
            borderRadius: 12,
            fontFamily: '"Space Grotesk", sans-serif'
        }
    },
    [theme.breakpoints.up('lg')]: {
        btn: {
            height: "48px",
            width: "330px",
            textTransform: 'none',
            borderRadius: 12,
            fontFamily: '"Space Grotesk", sans-serif'
        }
    }
}));

const GoogleSocialAuth = ({ handleLogin }) => {
    const classes = useStyles();
    const history = useHistory();

    const login = useGoogleLogin({
        flow: 'implicit',
        onSuccess: async (tokenResponse) => {
            try {
                await googleLogin(tokenResponse.access_token);
                handleLogin();
                history.push('/portfolio');
            } catch (err) {
                console.error('Google login failed:', err);
            }
        },
        onError: (err) => {
            console.error('Google login error:', err);
        }
    });

    return (
        <Button
            variant="contained"
            color="primary"
            onClick={() => login()}
            className={classes.btn}
            startIcon={<img.GoogleLogo />}
        >
            Продолжить с Google
        </Button>
    );
}

export default GoogleSocialAuth;
